
export default {
  props: {
    img: String,
    text1: String,
    text2: String,
  },
  data() {
    return {}
  },
}
